import React, { useState } from 'react'
import { without, isEqual } from 'lodash'
import { useAnalytics } from 'hooks'
import { Button, Modal, ModalNavHeader, Text, FlexColumn } from 'elements'
import ModalContent from 'components/app/ModalContent'
import { anomalyDescriptions } from '../constants'
import { formatSectionName, formatConfig } from '../utils/formatting'
import { SeverityThreshold, NumericThreshold } from './thresholds'

const thresholdComponents = { severity: SeverityThreshold }

const Threshold = (props) => {
  const Component = thresholdComponents[props.thresholdName] || NumericThreshold

  return <Component {...props} />
}

export default function ThresholdsModal({
  modal,
  configSection,
  configSections,
  setConfigSections,
}) {
  const { config } = configSection

  const [configState, setConfigState] = useState(config)
  const [submitting, setSubmitting] = useState(false)
  const [isValid, setIsValid] = useState(true)
  const analytics = useAnalytics()

  const handleSave = () => {
    setSubmitting(true)

    if (isEqual(config, configState)) {
      modal.onClose()
      return
    }

    //remove section
    const rest = without(configSections, configSection)

    const formattedConfig = formatConfig(configState)

    const editedSection = { ...configSection, config: formattedConfig }

    //put edited section back
    setConfigSections([...rest, editedSection])

    analytics.track('Report Template Thresholds Updated', {
      sectionName: editedSection.name,
      sectionType: editedSection.type,
      ...formattedConfig,
    })

    modal.onClose()
  }

  const description = anomalyDescriptions[configSection.name]
  const formattedName = formatSectionName(configSection.name)

  return (
    <Modal modal={modal}>
      <ModalNavHeader onClose={modal.onClose} titleText={formattedName} />
      <ModalContent>
        <FlexColumn>{description ? <Text mb="gigantic">{description}</Text> : null}</FlexColumn>
        {Object.keys(config).map((key) => (
          <Threshold
            key={key}
            thresholdName={key}
            configSection={configSection}
            value={configState[key]}
            onChange={(value) => setConfigState({ ...configState, [key]: value })}
            onValidate={setIsValid}
          />
        ))}
      </ModalContent>
      <Modal.Footer display="flex" alignItems="center">
        <Button mr="medium" kind="secondary" onClick={handleSave} disabled={submitting || !isValid}>
          {!submitting ? 'Save' : 'Saving...'}
        </Button>
        <Button onClick={() => modal.onClose()} mr="xxxlarge">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
